import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GanttComponent } from './gantt-components/gantt/gantt.component';
import { GanttHeaderComponent } from './gantt-components/gantt-header/gantt-header.component';
import { GanttGridComponent } from './gantt-components/gantt-grid/gantt-grid.component';
import { DateTransformPipe } from './gantt-pipes/date-transform/date-transform.pipe';

@NgModule({
  declarations: [
    GanttComponent,
    GanttHeaderComponent,
    GanttGridComponent,
    DateTransformPipe
  ],
  imports: [CommonModule],
  exports: [GanttComponent]
})
export class GanttModule { }
